/**
 * Given a list and a callback, executes the callback for each of the items
 * in the list, and returns a Promise that resolves with a list containing
 * the resolved value of each callback.
 */
export default <T, R>(array: T[], cb: (item: T, index: number, arr: T[]) => Promise<R> | R): Promise<R[]> => {
  return Promise.all(array.map((item, i, arr) => cb(item, i, arr)));
};
